import React, { useEffect, useRef } from "react";
import styles from "./PrivateNavigation.module.scss";
import styles2 from "../../layout/PrivateLayout/PrivateLayout.module.scss";

import classNames from "classnames";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../store/slices/auth/asyncThunks";

import { ReactComponent as DashboardIcon } from "../../assets/icons/menu_dashboard.svg";
import { ReactComponent as ClassesIcon } from "../../assets/icons/menu_classes.svg";
import { ReactComponent as StudentsIcon } from "../../assets/icons/menu_students.svg";
import { ReactComponent as StaffIcon } from "../../assets/icons/menu_staff.svg";
import { ReactComponent as SettingsIcon } from "../../assets/icons/menu_settings.svg";
import { ReactComponent as Notification } from "../../assets/icons/notifications.svg";
import { ReactComponent as Logout } from "../../assets/icons/logout.svg";
import {
  selectLoggedInUserDetails,
  selectLoggedInUserRole,
} from "../../store/slices/user/slice";
import { selectedSchool } from "../../store/slices/school/slice";
import { fetchSchool } from "../../store/slices/school/asyncThunks";
import { Chip, ModalNotifications, ModalSettings } from "../../components";

import { ROLES } from "../../utils/constants";
import { fetchNotifications } from "../../store/slices/notifications/asyncThunks";
import { notifyError } from "../../utils/notify";

const PrivateNavigation = ({ isMobile }) => {
  const dispatch = useDispatch();
  const userRole = useSelector(selectLoggedInUserRole);
  const getSelectedSchool = useSelector(selectedSchool);
  const logedInUserDetails = useSelector(selectLoggedInUserDetails);
  const modalRef = useRef();
  const modalNotifRef = useRef();

  const makeLogout = () => {
    dispatch(logout());
  };

  useEffect(() => {
    dispatch(fetchSchool({}));
  }, [dispatch]);

  const showNotificationsModal = () => {
    dispatch(fetchNotifications()).then((promise) => {
      if (promise.type.includes("fulfilled")) {
        modalNotifRef.current.show();
      } else {
        notifyError(promise.error.message);
      }
    });
  };

  return (
    <>
      {!isMobile ? (
        <nav className={classNames(styles.navbar)}>
          {getSelectedSchool && (
            <div className={styles.logoContainer}>
              {getSelectedSchool.logoUrl ? (
                <img
                  src={getSelectedSchool.logoUrl}
                  className={styles.logoImg}
                  alt="School logo"
                />
              ) : (
                <h1>{getSelectedSchool.name}</h1>
              )}
            </div>
          )}

          <ul className={classNames(styles.navbarContainer)}>
            <li>
              <NavLink
                to="/"
                className={(navData) =>
                  navData.isActive
                    ? styles.activeNavLink
                    : styles.notActiveNavLink
                }
              >
                <div className={styles.activeNavLinkRectangle}></div>
                <DashboardIcon className={styles.navigationIcon} />
                <span>Dashboard</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/classes"
                className={(navData) =>
                  navData.isActive
                    ? styles.activeNavLink
                    : styles.notActiveNavLink
                }
              >
                <div className={styles.activeNavLinkRectangle}></div>
                <ClassesIcon className={styles.navigationIcon} />
                <span>Classes</span>
              </NavLink>
            </li>
            {/* <li>
          <NavLink
            to="/teachers"
            className={(navData) =>
              navData.isActive ? styles.activeNavLink : ""
            }
          >
            <div className={styles.activeNavLinkRectangle}></div>
            <span>Teachers</span>
          </NavLink>
        </li> */}
            <li>
              <NavLink
                to="/students?page=1"
                className={(navData) =>
                  navData.isActive
                    ? styles.activeNavLink
                    : styles.notActiveNavLink
                }
              >
                <div className={styles.activeNavLinkRectangle}></div>
                <StudentsIcon className={styles.navigationIcon} />
                <span>Students</span>
              </NavLink>
            </li>

            {ROLES.ADMIN === userRole && (
              <li>
                <NavLink
                  to="/staff?page=1"
                  className={(navData) =>
                    navData.isActive
                      ? styles.activeNavLink
                      : styles.notActiveNavLink
                  }
                >
                  <div className={styles.activeNavLinkRectangle}></div>
                  <StaffIcon className={styles.navigationIcon} />
                  <span>Staff</span>
                </NavLink>
              </li>
            )}

            {ROLES.ADMIN === userRole && (
              <li>
                <NavLink
                  to="/settings"
                  className={(navData) =>
                    navData.isActive
                      ? styles.activeNavLink
                      : styles.notActiveNavLink
                  }
                >
                  <div className={styles.activeNavLinkRectangle}></div>
                  <SettingsIcon className={styles.navigationIcon} />
                  <span>Settings</span>
                </NavLink>
              </li>
            )}
          </ul>

          <div className={styles.bottomContainer} onClick={makeLogout}>
            <div className={styles.bottomContainerLogout}>
              <div>
                <Logout
                  style={{ transform: "rotate(180deg)", marginBottom: "2px" }}
                />
                <span>LOGOUT</span>
              </div>
            </div>
          </div>
        </nav>
      ) : (
        <nav className={classNames(styles.navbarMobile)}>
          <div className={styles2.bottomContainerProfileMobile}>
            <Notification onClick={() => showNotificationsModal()} />
            <div
              className={styles2.userContainer}
              onClick={() => modalRef.current.show()}
            >
              <Chip
                {...logedInUserDetails}
                img={logedInUserDetails.profilePhoto}
              />
              {logedInUserDetails.firstName + " " + logedInUserDetails.lastName}
            </div>
          </div>
          {getSelectedSchool && (
            <div className={styles.logoContainer}>
              {getSelectedSchool.logoUrl ? (
                <img
                  src={getSelectedSchool.logoUrl}
                  className={styles.logoImg}
                  alt="School logo"
                />
              ) : (
                <h1>{getSelectedSchool.name}</h1>
              )}
            </div>
          )}

          <ul className={classNames(styles.navbarContainer)}>
            <li>
              <NavLink
                to="/"
                className={(navData) =>
                  navData.isActive
                    ? styles.activeNavLink
                    : styles.notActiveNavLink
                }
              >
                <div className={styles.activeNavLinkRectangle}></div>
                <DashboardIcon className={styles.navigationIcon} />
                <span>Dashboard</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/classes"
                className={(navData) =>
                  navData.isActive
                    ? styles.activeNavLink
                    : styles.notActiveNavLink
                }
              >
                <div className={styles.activeNavLinkRectangle}></div>
                <ClassesIcon className={styles.navigationIcon} />
                <span>Classes</span>
              </NavLink>
            </li>
            {/* <li>
          <NavLink
            to="/teachers"
            className={(navData) =>
              navData.isActive ? styles.activeNavLink : ""
            }
          >
            <div className={styles.activeNavLinkRectangle}></div>
            <span>Teachers</span>
          </NavLink>
        </li> */}
            <li>
              <NavLink
                to="/students?page=1"
                className={(navData) =>
                  navData.isActive
                    ? styles.activeNavLink
                    : styles.notActiveNavLink
                }
              >
                <div className={styles.activeNavLinkRectangle}></div>
                <StudentsIcon className={styles.navigationIcon} />
                <span>Students</span>
              </NavLink>
            </li>

            {ROLES.ADMIN === userRole && (
              <li>
                <NavLink
                  to="/staff?page=1"
                  className={(navData) =>
                    navData.isActive
                      ? styles.activeNavLink
                      : styles.notActiveNavLink
                  }
                >
                  <div className={styles.activeNavLinkRectangle}></div>
                  <StaffIcon className={styles.navigationIcon} />
                  <span>Staff</span>
                </NavLink>
              </li>
            )}

            {ROLES.ADMIN === userRole && (
              <li>
                <NavLink
                  to="/settings"
                  className={(navData) =>
                    navData.isActive
                      ? styles.activeNavLink
                      : styles.notActiveNavLink
                  }
                >
                  <div className={styles.activeNavLinkRectangle}></div>
                  <SettingsIcon className={styles.navigationIcon} />
                  <span>Settings</span>
                </NavLink>
              </li>
            )}
          </ul>

          <div className={styles.bottomContainer} onClick={makeLogout}>
            <div className={styles.bottomContainerLogout}>
              <div>
                <Logout
                  style={{ transform: "rotate(180deg)", marginBottom: "2px" }}
                />
                <span>LOGOUT</span>
              </div>
            </div>
          </div>
        </nav>
      )}
      <ModalSettings modalRef={modalRef} userDetails={logedInUserDetails} />
      <ModalNotifications modalRef={modalNotifRef} />
    </>
  );
};

export default PrivateNavigation;
